import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { positions, Provider } from "react-alert";
import AlertTemplate from "react-alert-template-basic";
import { SquareLoader } from "react-spinners";

import Home from "../src/Pages/Home/Home";
import Navbar from "./Components/Navbar";
import About from "../src/Pages/About/About";
import Skills from "../src/Pages/Skills/Skills";
import Work from "../src/Pages/Work/Work";
import Contact from "../src/Pages/Contact/Contact";
import "./loadingStyle.css";

const options = {
  timeout: 1700,
  position: positions.TOP_RIGHT,
  offset: "9px",
  transition: "scale",
};

const optionsTwo = {
  timeout: 3000,
  position: positions.BOTTOM_RIGHT,
  offset: "9px",
};

export default function App() {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1400);
  }, []);

  return (
    <div>
      {loading ? (
        <div className="loading">
          <SquareLoader color="#F9880D" loading={loading} size={35} />
        </div>
      ) : (
        <Router>
          <Switch>
            <Route path="/About">
              <Navbar />
              <About />
            </Route>

            <Route path="/Skills">
              <Navbar />
              <Skills />
            </Route>

            <Route path="/Work">
              <Provider template={AlertTemplate} {...options}>
                <Navbar />
                <Work />
              </Provider>
            </Route>

            <Route path="/Contact">
              <Provider template={AlertTemplate} {...optionsTwo}>
                <Navbar />
                <Contact />
              </Provider>
            </Route>

            <Route path="/">
              <Navbar />
              <Home />
            </Route>
          </Switch>
        </Router>
      )}
    </div>
  );
}
